import React, { Suspense } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  EuiFlexGroup,
  EuiPage,
  EuiPageBody,
  EuiPageContent,
  EuiFocusTrap,
} from 'stable-eui';
import { ToastProvider } from 'react-toast-notifications';
// import useOnlineStatus from '@rehooks/online-status';
import { RootState } from 'reducers/root';
import { Loading } from 'components/common';
import { get } from 'lodash';
import { notification } from 'antd';
import searchService from 'api/search.service';
import commonService from 'api/common.service';
import { getMessage, idb } from 'utils';
import HeaderSearchModal from './headers/HeaderSearch/Modal';
import Routes from './routes';
import AppHeader from './app.header';
import NavDrawer from './nav.drawer';
import AsideBar from './aside';
import './styles.less';

const AppLayout = () => {
  const navLockStatus = useSelector((state) => !!state.app.navLockStatus);
  const [modalType, setModalType] = React.useState(
    localStorage.getItem('searchType') || 'PHIEU_GUI'
  );

  const [facts, setFacts] = React.useState([]);
  const [listening, setListening] = React.useState(false);

  const history = useHistory();

  const [isGlobalModalVisible, setIsGlobalModalVisible] = React.useState(false);
  const [globalModalData, setGlobalModalData] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  const goTo = (path) => {
    history.push(path);
  };

  const handleGlobalSearch = async ({ type, searchText }) => {
    setModalType(type);
    localStorage.setItem('searchType', type);
    setIsLoading(true);
    setIsGlobalModalVisible(true);
    searchService
      .getTrack({
        searchType: type,
        tracking_code: searchText,
        locale: localStorage.getItem('language'),
      })
      .then((res) => {
        setGlobalModalData({ ...res.data, searchText });
      })
      .finally(() => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsGlobalModalVisible(false);
        notification.info({
          message: getMessage('not_found'),
        });
      });
    return Promise.resolve();
  };

  React.useEffect(() => {
    let events;
    if (!listening) {
      events = new EventSource(
        'http://localhost:6060/events' // Similarly, if you use a reverse proxy, proxy_buffering is ON by default, thus you have to add proxy_buffering off;.
        // withCredentials: true, //  CORS credentials se
      );

      events.onmessage = (event) => {
        const parsedData = JSON.parse(event.data);
        console.log('Received Event from server: ', event);
        setFacts((facts) => facts.concat(parsedData));
      };

      events.onerror = (err) => {
        // error log here
        console.log('err', err);
        events.close();
      };

      setListening(true);
    }
    return () => {
      events && events.close();
    };
  }, [listening, facts]);

  React.useEffect(() => {
    idb.exec();
    commonService.fetchDistrictsWards().then((v) => {
      const { districts, wards } = v;
      idb.saveDistrictsWards(districts, wards);
    });
  }, []);

  return (
    <ToastProvider placement="bottom-left">
      <EuiFlexGroup
        responsive={true}
        onClick={(ev) => {
          // @ts-ignore
          const type = ev.target.title;
          if (ev.ctrlKey && type) {
            // @ts-ignore
            const searchText = ev.target.textContent || ev.target.value;
            handleGlobalSearch({
              type,
              searchText,
            });
          }
        }}
      >
        <EuiFocusTrap>
          <div className="page-wrapper">
            <AppHeader
              handleGlobalSearch={handleGlobalSearch}
              modalType={modalType}
            />
            <EuiPage className="euiNavDrawerPage" style={{ padding: 0 }}>
              {/* <NavDrawer goTo={goTo} /> */}
              <AsideBar
                goTo={goTo}
                collapsed={false}
                rtl={false}
                toggled={navLockStatus}
                handleToggleSidebar={(v) => {
                  console.log('toggle', v);
                }}
              />
              <EuiPageBody
                className="euiNavDrawerPage__pageBody"
                style={{ marginLeft: 0 }}
              >
                <EuiPageContent style={{ overflow: 'auto' }}>
                  {/* <BrowserRouter> */}
                  <Suspense
                    fallback={<Loading title={getMessage('loading')} />}
                  >
                    <Routes />
                  </Suspense>
                  {/* </BrowserRouter> */}
                </EuiPageContent>
              </EuiPageBody>
              {/* <Layout.Footer className="app-footer">{appConfig.footer}</Layout.Footer> */}
            </EuiPage>
          </div>
        </EuiFocusTrap>
        <HeaderSearchModal
          closeModal={() => {
            setIsGlobalModalVisible(false);
            setGlobalModalData({});
          }}
          type={modalType}
          isLoading={isLoading}
          data={isLoading ? {} : globalModalData}
          visible={isGlobalModalVisible}
        />
      </EuiFlexGroup>
    </ToastProvider>
  );
};

export default AppLayout;
